import React, { Component } from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';

import styles from './Navbar2Style.js';
import logo from '../../../img/assets/logo_50.png';

class Navbar extends Component {
    render() {
        return (
            <nav className="navbar navbar-default navbar-fixed-top" style={styles.navbar}>
                <div className="container">
                    <div className="navbar-header">
                        <div>
                            <button
                                type="button"
                                className="navbar-toggle collapsed"
                                data-toggle="collapse"
                                data-target=".main_navbar"
                                aria-expanded="false">

                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                        </div>
                        <div className="navbar-brand">
                            <Link to="/">
                                <img className="img img-responsive" style={styles.logo} alt="logo" src={logo}></img>
                            </Link>
                            <Link to="/" style={styles.brand}>AETHILUS</Link>
                        </div>
                    </div>
                    <div className="collapse navbar-collapse main_navbar">
                        <ul className="nav navbar-right navbar-nav">
                            <li><Link to="/products" style={styles.navText}>OUR PRODUCTS</Link></li>
                            <li><Link to="/services" style={styles.navText}>OUR SERVICES</Link></li>
                            <li><Link to="/about" style={styles.navText}>ABOUT US</Link></li>
                            {/*<li><Link to="/blog" style={styles.navText}>BLOG</Link></li>*/}
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default Radium(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/2/Navbar2.js